<template>
  <layout-auth>
    <div>
      <div class="auth-title">
        <h2>Redefinir Senha</h2>
        <validation-errors
          :errors="validationErrors"
          v-if="validationErrors"
        ></validation-errors>
      </div>
      <div class="auth-body">
        <p>
          Coloque sua nova senha agora! E guarde bem ela, porque você vai
          precisar depois ok?
        </p>
        <div class="auth-form">
          <form v-on:submit.prevent>
            <label for="email">Email</label>
            <input v-model="email" id="email" type="email" />
            <label for="password">Nova Senha</label>
            <input v-model="password" id="password" type="password" />
            <label for="password">Confirme a Senha</label>
            <input
              v-model="password_confirmation"
              id="password_confirmation"
              type="password"
            />
            <button
              @click="handleResetPassword"
              class="mt-5 button button-primary"
            >
              Redefinir Senha
            </button>
          </form>
        </div>
      </div>
    </div>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../layouts/LayoutAuth";
import ValidationErrors from "./ValidationErrors";
export default {
  data() {
    return {
      resetToken: this.$route.query.token,
      email: "",
      password: "",
      password_confirmation: "",
      validationErrors: ""
    };
  },
  components: {
    "layout-auth": LayoutAuth,
    "validation-errors": ValidationErrors
  },
  methods: {
    handleResetPassword() {
      let email = this.email;
      let password = this.password;
      let password_confirmation = this.password_confirmation;
      let token = this.resetToken;

      this.$store
        .dispatch("passwordReset", {
          email,
          password,
          password_confirmation,
          token
        })
        .then(() => {
          this.$toasted.success(
            `Ótimo! Seu password foi redefinido. Agora é só logar!`,
            { icon: "done_outline" }
          );
          this.$router.push("/desafio");
        })
        .catch(error => {
          this.$toasted.error(`Ops.. ocorreu um erro.`);
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
          }
        });
    }
  }
};
</script>
